import { useFormContextStateSelector } from "../useFormContextStateSelector";

export const useGetTitle = () => {
  return useFormContextStateSelector(({ header: {title} }) => title);
}